export const FETCH_LANGUAGES_LIST = 'fetchLanguagesList';
export const SELECT_LANGUAGE = 'selectLanguage';
